import type { ReactNode } from 'react';
import { Box, Icon, Text } from '@zillow/constellation-10';

type StatCardProps = {
  label: string;
  value: number;
  icon?: ReactNode;
};

export const StatCard = ({ label, value, icon }: StatCardProps) => {
  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flex: { base: '1 1 40%', md: '1' },
        padding: '400',
        border: '1px solid',
        borderColor: 'border.muted',
        borderRadius: '200',
        height: '110px',
        gap: '200',
      }}
    >
      {icon && <Icon css={{ color: 'text.subtle' }}>{icon}</Icon>}
      <Text textStyle="body-sm" css={{ color: 'text.subtle', textAlign: 'center' }}>
        {label}
      </Text>
      <Text textStyle="heading-sm">{value}%</Text>
    </Box>
  );
};
